// ----------------------------------------------------------------------------
// Component: Product Recommendations
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';
import Swiper, { Scrollbar, A11y } from 'swiper';
import { initializeProducts } from '../product/product';
import '../../snippets/card/card';

// Styles
import 'swiper/css';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import './_product-recommendations.scss';

// -------------------------------------
// Variables
// -------------------------------------


// -------------------------------------
// Dynamic Recommendations
// -------------------------------------
$(document).ready(function(){
    var loadProductRecommendationsIntoSection = function() {

        // Look for an element with class 'product-recommendations'
        var productRecommendationsSection = document.querySelector(".product-recommendations--algorithm .product-recommendations__wrapper");
        if (productRecommendationsSection === null) { return; }

        // Read product id from data attribute
        var productId = productRecommendationsSection.dataset.productId;

        // Read limit from data attribute
        var limit = productRecommendationsSection.dataset.limit;
        var productType = productRecommendationsSection.dataset.productType;

        // Build request URL
        var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;

        // Create request and submit it using Ajax
        var request = new XMLHttpRequest();
        request.open("GET", requestUrl);
        request.onload = function() {
            if (request.status >= 200 && request.status < 300) {
                var container = document.createElement("div");
                container.innerHTML = request.response;
                productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;

                var YotpoAPI = new Yotpo.API(yotpo);
                YotpoAPI.refreshWidgets();

                var productRecommendationSwiper = new Swiper(".carousel--product-recommendations", {
                    // Optional parameters
                    modules: [Scrollbar, A11y],
                    slidesPerView: 1.6,
                    spaceBetween: 20,
                    observer: true,
                    observeParents: true,
                    a11y: false,
                    watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.

                    breakpoints: {
                        // when window width is >= 680px
                        680: {
                            slidesPerView: 3,
                            spaceBetween: 20
                        },
                        1024: {
                            slidesPerView: 4,
                            spaceBetween: 30
                        }
                    },

                    scrollbar: {
                        el: '.recommended-swiper-scrollbar',
                        draggable: true,
                    },
                });

                initializeProducts();
                initModalFormIncrement();

                var backgroundTextComponent = $('.product-recommendations__background-text');
                $(window).scroll(function(event) {
                    backgroundTextComponent.each(function(i, el){
                        var $this = $(el);
                        var windowTop = $(window).scrollTop();
                        var elementTop = $this.offset().top - 1000;
                        var leftPosition = windowTop - elementTop;

                        $this.css("transform", 'translateX('+leftPosition+'px)');
                    });
                });
            }
       };
       request.send();
  };

    const fetchProductRecommendations = () => {

        let productRecommendationModal = document.querySelector('.product-recommendations--cart');
        if (productRecommendationModal === null) { return; }
        let productId = productRecommendationModal.dataset.productId;
        let limit = productRecommendationModal.dataset.limit;
        let cartIds = iamotaCart.map((item) => item.product_id.toString());


        // Build request URL
        var requestUrl = "/recommendations/products?section_id=product-recommendations--cart&limit="+limit+"&product_id="+productId;

        // Create request and submit it using Ajax
        var request = new XMLHttpRequest();
        request.open("GET", requestUrl);
        request.onload = function() {
            if (request.status >= 200 && request.status < 300) {
                var container = document.createElement("div");
                container.innerHTML = request.response;
                productRecommendationModal.parentElement.innerHTML = container.querySelector(".product-recommendations--cart").innerHTML;
                let createdProductCards = document.querySelectorAll('.js--product-recommendations-cart .card--product');

                createdProductCards.forEach(card => {
                    let cardProductId = card.dataset.productId;
                    let cardProductWrapper = card.parentElement;

                    if (cartIds.includes(cardProductId)) {
                        cardProductWrapper.remove();
                    }
                });

                var productRecommendationSwiper = new Swiper(".carousel--product-recommendations", {
                    // Optional parameters
                    modules: [Scrollbar, A11y],
                    slidesPerView: 1.6,
                    spaceBetween: 20,
                    observer: true,
                    observeParents: true,
                    a11y: false,
                    watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.

                    breakpoints: {
                        // when window width is >= 680px
                        680: {
                            slidesPerView: 3,
                            spaceBetween: 20
                        },
                        1024: {
                            slidesPerView: 4,
                            spaceBetween: 30
                        }
                    },

                    // // Navigation arrows
                    scrollbar: {
                        el: '.recommended-swiper-scrollbar',
                        draggable: true,
                    },
                });
                initializeProducts();
                initModalFormIncrement();

                var backgroundTextComponent = $('.product-recommendations__background-text');
                $(window).scroll(function(event) {
                    backgroundTextComponent.each(function(i, el){
                        var $this = $(el);
                        var windowTop = $(window).scrollTop();
                        var elementTop = $this.offset().top - 1000;
                        var leftPosition = windowTop - elementTop;

                        $this.css("transform", 'translateX('+leftPosition+'px)');
                    });
                });
            }
        };
        request.send();
    };

    const renderingRecommendationsReviews = () => {

    };

    // If your section has theme settings, the theme editor
    // reloads the section as you edit those settings. When that happens, the
    // recommendations need to be fetched again.
    // See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
   //  document.addEventListener("shopify:section:load", function(event) {
   //      if (event.detail.sectionId === "product-recommendations") {
   //          loadProductRecommendationsIntoSection();
   //      }
   // });

    // Fetching the recommendations on page load
    loadProductRecommendationsIntoSection();
    fetchProductRecommendations();


    function handleSlides(swiperEl) {
        swiperEl.slides.forEach(function(slide, index) {
            let slideLink = slide.querySelector('a');
            slideLink.addEventListener('focus', function(e) {
                swiperEl.slideTo(index);
            })
        });
    }

    function initModalFormIncrement() {
        const $formInput = $('.form__input[type="number"]');

        if ($formInput) {
            $('.modal--add-to-cart .form__increment').on('click', function() {


                var $button = $(this);
                var oldValue = $button.parent().find('input').val();

                $button.parent().find('input').focus();

                if ($button.hasClass('form__increment--up')) {
                    var newVal = parseFloat(oldValue) + 1;
                }
                else {
                    // Don't allow decrementing below zero
                    if (oldValue > 1) {
                        var newVal = parseFloat(oldValue) - 1;
                    } else {
                        newVal = 1;
                    }
                }

                $button.parent().find('input').val(newVal).trigger('change');
                $('button[name=update_cart]').prop('disabled', false);

            });
        }
    }


    $(".carousel--product-recommendations").each(function(index, element){
        var $this = $(this);

        // Generate unique class for each collection list slider
        $this.addClass("product-recommendation-instance-" + index);

        // Generate unique btn classes for slider arrows
        $this.parents('.product-recommendations').find(".swiper-scrollbar").addClass("swiper-scrollbar-" + index);

        productRecommendationSwiper.slides.forEach(function(slide, index) {
            let slideLink = slide.querySelector('a');
            slideLink.addEventListener('focus', function(e) {
                productRecommendationSwiper.slideTo(index);
            })
        });
    });
});







